import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSplit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.25 21.6C11.25 21.8209 11.4291 22 11.65 22H12.35C12.5709 22 12.75 21.8209 12.75 21.6V19.75H18C19.5188 19.75 20.75 18.5188 20.75 17V7C20.75 5.48122 19.5188 4.25 18 4.25H12.75V2.4C12.75 2.17909 12.5709 2 12.35 2H11.65C11.4291 2 11.25 2.17909 11.25 2.4V21.6ZM12.75 5.75V18.25H18C18.6904 18.25 19.25 17.6904 19.25 17V7C19.25 6.30964 18.6904 5.75 18 5.75H12.75Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.25 7C3.25 5.48122 4.48122 4.25 6 4.25H9.6C9.82091 4.25 10 4.42909 10 4.65V5.35C10 5.57091 9.82091 5.75 9.6 5.75H6C5.30964 5.75 4.75 6.30964 4.75 7V17C4.75 17.6904 5.30964 18.25 6 18.25H9.6C9.82091 18.25 10 18.4291 10 18.65V19.35C10 19.5709 9.82091 19.75 9.6 19.75H6C4.48122 19.75 3.25 18.5188 3.25 17V7Z",
		fill: "currentColor"
	})]
});
export { SvgIconSplit as ReactComponent };
